import React from 'react';
import css from './GoLive.module.scss';
import {Section} from '../section/Section';
import {ButtonV2} from '../../../system/ButtonV2/ButtonV2';
import {SETUP_STEP_TYPES} from '../../../setupSteps/SetupStepTypes';

export const GoLiveSection: React.FC<{
  type: SETUP_STEP_TYPES;
}> = ({type}) => {
  return (
    <Section type={type}>
      <div className={css.section}>
        <div className={css.section_header_container}>
          <div className={css.section_title}>Add widget(s) to OBS</div>
          <div className={css.section_text}>
            Add Pulsoid heart rate widgets to your stream on OBS Studio,
            Streamlabs OBS, XSplit, Twitch Studio, via embed links.
          </div>
          <ul className={css.list_text}>
            <li>
              You can include multiple heart rate widgets as separate Browser
              Sources to combine various types.
            </li>
            <li>
              Share your widget link with friends to create an interactive and
              engaging party stream.
            </li>
          </ul>
        </div>
        <iframe
          className={css.section_video}
          src="https://www.youtube.com/embed/zcDyvDf6cgQ"
          title="How to add a heart rate widget in OBS as a Browser Source"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
        <ButtonV2
          size="small"
          className={css.how_to_add_widget_button}
          href="https://blog.pulsoid.net/post/how-to-add-browser-source-in-obs-streamlabs-obs-twitch-studio-xsplit"
          target="_blank"
        >
          How to add widget in OBS
        </ButtonV2>
      </div>
      <div className={`${css.section} ${css.section_integrations_api}`}>
        <div className={css.section_title}>Integrations and API</div>
        <div className={css.section_text}>
          Pulsoid offers integrations with a variety of streaming software and
          plugins. You can control room lighting, send automated clips to
          Discord, or change your VTube avatar's emotions. Explore the available
          integrations for content creators and VRChat players.
        </div>
        <ButtonV2
          size="small"
          type="secondary"
          className={css.secondary_button}
          target="_blank"
          href="https://pulsoid.net/ui/integrations"
        >
          Explore Integrations
        </ButtonV2>
        <div className={`${css.section_text} ${css.text_margin_top}`}>
          For even more unique experiences, consider using the Pulsoid API.
        </div>
        <ButtonV2
          size="small"
          type="secondary"
          className={css.secondary_button}
          target="_blank"
          href="https://docs.pulsoid.net/"
        >
          API documentation ↗
        </ButtonV2>
      </div>
    </Section>
  );
};
